"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var callout_pc_svg_1 = __importDefault(require("images/components/estimate_banners/form_with_image/callout_pc.svg"));
var callout_sp_svg_1 = __importDefault(require("images/components/estimate_banners/form_with_image/callout_sp.svg"));
var Promotion = function (props) {
    var withIcon = props.withIcon === undefined || props.withIcon;
    var isSmartPhone = props.smartphone === true;
    return (React.createElement("div", { className: (0, classnames_1.default)('estimateEntryBanner-Promotion', "estimateEntryBanner-Promotion-".concat(props.position)) },
        withIcon && (React.createElement("div", { className: "estimateEntryBanner-Promotion_IconWrapper" },
            React.createElement("i", { className: classnames_1.default.apply(void 0, __spreadArray(['i', 'taxonomy', 'icon'], (props.categoryIconClasses || []), false)) }))),
        React.createElement("div", { className: "estimateEntryBanner-Promotion_Body" },
            React.createElement("span", { className: "estimateEntryBanner-Promotion_CategoryName" },
                "\u3042\u306A\u305F\u306E",
                props.categoryName,
                "\u306E\u8CB7\u53D6\u4FA1\u683C\u3092"),
            React.createElement("div", { className: "estimateEntryBanner-Promotion_CalloutContainer" },
                React.createElement("img", { src: isSmartPhone ? callout_sp_svg_1.default : callout_pc_svg_1.default, className: "lazyload", alt: "estimate-entry-banner", width: isSmartPhone ? 246 : 248, height: isSmartPhone ? 14 : 15 })),
            React.createElement("div", { className: "estimateEntryBanner-Promotion_MaxRequest" },
                React.createElement("span", { className: "estimateEntryBanner-Promotion_Text-accent" },
                    "\u6700\u5927",
                    props.maxEstimateRequestSize,
                    "\u793E\u304C",
                    isSmartPhone && (React.createElement("br", null))),
                React.createElement("span", { className: "estimateEntryBanner-Promotion_Text-dotAccent" }, "\u4E00\u62EC\u67FB\u5B9A"),
                React.createElement("span", { className: "estimateEntryBanner-Promotion_Text-accent" }, "\uFF01")))));
};
exports.default = Promotion;
